import ArticleEffect from "@/components/effect/article-effetc";

import { useGSAP } from "@gsap/react";
import gsap from "gsap";

import { useEffect, useRef } from "react";

import HeroWorkSummary from "./hero-work-summary";
import HeroGuestboard from "./hero-guestboard-summary";
import SubNav from "@/components/shared/sub-nav";

export default function HomeHero() {
  // Main Text
  const spanRefs = useRef<HTMLSpanElement[]>([]);
  //Sub text
  const titlePreRef = useRef<HTMLSpanElement[]>([]);
  const titlePostRef = useRef<HTMLSpanElement[]>([]);

  //description Ref
  const desRef = useRef<HTMLDivElement>(null);
  const summaryRef = useRef<HTMLDivElement>(null);
  const bgEffectRef = useRef<HTMLDivElement>(null);
  const lightEffectRef = useRef<HTMLDivElement>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  const pallaxRefs = useRef<HTMLElement[]>([]);

  useGSAP(
    () => {
      const spans = spanRefs.current;
      if (!bgEffectRef.current) return;
      const bgEffect = bgEffectRef.current;

      if (!spans.length) return;
      const tl = gsap.timeline();
      const tlBackground = gsap.timeline();

      // 1. Background - 더 부드럽게
      tlBackground.fromTo(
        bgEffect,
        {
          scale: 1.4,
          opacity: 0,
          filter: "blur(20px)",
        },
        {
          scale: 1,
          duration: 1.4,
          opacity: 0.7,
          ease: "expo.inOut",
          filter: "blur(0px)",
        }
      );

      tl.from(
        spans,
        {
          opacity: 0,
          y: 50,
          rotateX: -90,
          filter: "blur(20px)",
          stagger: 0.03,
          duration: 0.4,
          ease: "power4.out",
          delay: 1.1,
        },
        "-=0.1"
      );

      // 3. Sub text - 더 부드럽게
      tl.from(
        titlePreRef.current,
        {
          opacity: 0,
          y: 30,
          filter: "blur(15px) grayscale(0%)",
          stagger: 0.035,
          duration: 0.5,
          ease: "power4.out",
        },
        "-=0.3"
      );

      tl.from(
        titlePostRef.current,
        {
          opacity: 0,
          y: 30,
          filter: "blur(15px) grayscale(0%)",
          stagger: 0.035,
          duration: 0.5,
          ease: "power4.out",
        },
        "-=0.5"
      );

      // 4. Description - 슬라이드 인
      tl.from(
        desRef.current,
        {
          x: -30,
          opacity: 0,
          filter: "blur(10px)",
          duration: 0.7,
          ease: "power4.out",
        },
        "-=0.3"
      );

      tl.from(
        summaryRef.current,
        {
          x: -30,
          opacity: 0,
          filter: "blur(10px)",
          duration: 0.8,
          ease: "power4.out",
        },
        "-=0.45"
      );

      tl.from(
        lightEffectRef.current,
        {
          y: -130,
          opacity: 0,
          filter: "blur(10px)",
          duration: 3,
          ease: "power4.out",
        },
        "-=0.45"
      );

      pallaxRefs.current.forEach((el, idx) => {
        if (!el) return;
        const depth = idx + 1;
        const moveMment = -70 * depth;

        gsap.to(el, {
          y: moveMment,
          ease: "none",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top top",
            end: "center top",

            scrub: 2,
          },
        });
      });
    },
    { scope: sectionRef, revertOnUpdate: true, dependencies: [] }
  );

  // Mobile, Pc 분기
  useEffect(() => {
    const mm = gsap.matchMedia();
    mm.add("(min-width: 1024px)", () => {
      gsap.to(".box", {
        x: 200,
        scrollTrigger: { trigger: ".box" },
      });
    });

    mm.revert();
  }, []);

  // useLayoutEffect(() => {
  //   const setVh = () => {
  //     const vh = window.innerHeight;

  //     document.documentElement.style.setProperty("--vh", `${vh}px`);
  //   };

  //   setVh();
  //   window.addEventListener("resize", setVh);

  //   return () => {
  //     window.removeEventListener("resize", setVh);
  //   };
  // }, []);

  return (
    <>
      <div className="absolute w-full h-lvh overflow-hidden">
        {" "}
        <div
          className="absolute   h-lvh will-change-transform transform-gpu w-full  top-0 left-0 md:inset-0 z-0 overflow-hidden bg-cover bg-bottom md:bg-center"
          ref={bgEffectRef}
          style={{ opacity: 0, transform: "scale(1.4)" }}
        >
          <ArticleEffect />
          {/* 하단 이미지 */}
          <div
            className="absolute inset-0 w-full h-full bg-cover bg-center z-0 [background-position-x:70%]"
            style={{ backgroundImage: "url(/img/heros/b50.jpg)" }}
            ref={(el) => (pallaxRefs.current[0] = el!)}
          />
          <div
            className="absolute inset-0 w-full h-full bg-cover bg-center z-5"
            style={{ backgroundImage: "url(/img/heros/b51.png)" }}
            ref={(el) => (pallaxRefs.current[1] = el!)}
          />

          {/* PNG 상단 이미지 */}
          <div
            className="absolute inset-0 w-full h-full bg-cover md:bg-center z-10 [background-position-x:70%]"
            style={{ backgroundImage: "url(/img/heros/b50.png)" }}
            ref={(el) => (pallaxRefs.current[2] = el!)}
          >
            {/* 그라데이션 오버레이 */}
            <div className="absolute inset-0 w-full h-full bg-linear-to-b from-transparent via-[#171717]/70 to-[#171717] z-20" />
            <div className="absolute bg-[#171717] w-full h-[500px] top-[99%]"></div>
          </div>
        </div>
      </div>

      <section ref={sectionRef} className="overflow-hidden  relative">
        <div className="grid-layout  md:grid flex pt-60 md:pt-75">
          <div className="leading-relaxed flex flex-col  mb-10 z-1">
            <div
              data-animate
              className="flex flex-col gap-4 leading-tight z-10 break-keep items-start md:pb-20 "
            >
              <div>
                <div className="inline-block text-zinc-50 font-montserrat">
                  {"항상 탐구하는 개발자".split("").map((e, i) => (
                    <span
                      key={`word:${i}`}
                      ref={(el) => {
                        if (el) {
                          spanRefs.current[i] = el;
                        }
                      }}
                      className="relative text-shadow-3x  text-xl md:text-2xl inline-block "
                      style={{
                        textShadow: "0 0 30px rgba(45, 212, 191, 0.3)",
                      }}
                    >
                      {e === " " ? "\u00A0" : e}
                    </span>
                  ))}
                </div>
                <div className="flex flex-col md:flex-row font-bold">
                  <div className=" w-full flex  mt-3 text-zinc-50  font-montserrat">
                    {"Front-end ".split("").map((e, i) => (
                      <span
                        key={`word:${i}`}
                        className="relative inline-block text-[clamp(3rem,5vw,4rem)]"
                        ref={(el) => {
                          if (el) {
                            titlePreRef.current[i] = el;
                          }
                        }}
                        style={{
                          display: "inline-block",
                        }}
                      >
                        {e === " " ? "\u00A0" : e}
                      </span>
                    ))}
                  </div>

                  <div className=" w-full flex  mt-3 text-zinc-50 font-montserrat">
                    {"Developer".split("").map((e, i) => (
                      <span
                        key={`word:${i}`}
                        className="relative inline-block text-[clamp(3rem,5vw,4rem)]"
                        ref={(el) => {
                          if (el) {
                            titlePostRef.current[i] = el;
                          }
                        }}
                        style={{
                          display: "inline-block",
                        }}
                      >
                        {e === " " ? "\u00A0" : e}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              <div
                ref={desRef}
                className="grid grid-cols-[1fr_auto] text-zinc-200 z-10 mt-10"
              >
                <div>
                  <p className="text-base md:text-base text-indigo-100">
                    프론트앤드 개발과 퍼블리싱을 주로 다룹니다
                  </p>
                  <p className="text-base text-zinc-500 mt-2">
                    React.js ㆍ Next.js ㆍ Tailwind ㆍ Nest
                  </p>
                </div>
              </div>
            </div>
            <div
              className="grid md:grid-cols-2   pb-10  pt-10"
              ref={summaryRef}
            >
              <div>
                <SubNav />
              </div>
              <div className="grid md:grid-cols-2 mt-15 md:mt-auto gap-10 ">
                {/* Works */}
                <HeroWorkSummary />
                <HeroGuestboard />
              </div>
            </div>
          </div>
        </div>{" "}
      </section>
    </>
  );
}
